import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dealer-invoice-invoice-info-page" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "action-bar" }
const _hoisted_4 = { class: "batch-actions" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = { class: "vxe-table-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff4d4f","margin-left":"4px","cursor":"help"} }, "原因", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  style: {"color":"#ff4d4f"}
}
const _hoisted_10 = { class: "action-links" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pagination-bar" }
const _hoisted_16 = { style: {"margin-bottom":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_OioTag = _resolveComponent("OioTag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_OioPagination = _resolveComponent("OioPagination")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_oio_modal = _resolveComponent("oio-modal")!
  const _component_ImportInvoiceInfoDialog = _resolveComponent("ImportInvoiceInfoDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oio_form, {
        layout: "inline",
        data: _ctx.searchForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_oio_form_item, { label: "开票信息编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.code,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.code) = $event)),
                placeholder: "请输入编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "经销商编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.distributorCode,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.distributorCode) = $event)),
                placeholder: "请输入经销商编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "客户ERP编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.distributorErpCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.distributorErpCode) = $event)),
                placeholder: "请输入客户ERP编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "审批状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.searchForm.approvalStatus,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.approvalStatus) = $event)),
                placeholder: "全部",
                "allow-clear": "",
                style: {"width":"130px"},
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalStatusTextMap, (text, key) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: key,
                      value: key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_oio_button, {
                type: "primary",
                onClick: _ctx.handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_oio_button, {
                style: {"margin-left":"8px"},
                onClick: _ctx.handleReset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.handleAdd
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增开票信息")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isDistributor && !_ctx.isSeller)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 1,
              onClick: _ctx.handleImport
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量导入")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isOperationCenter)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 2,
              loading: _ctx.exportLoading,
              onClick: _ctx.handleBatchExport
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量导出")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isOperationCenter)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 3,
              onClick: _ctx.handleBatchApprove
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量审核")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isOperationCenter)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 4,
              danger: "",
              onClick: _ctx.handleBatchDelete
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量删除")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_oio_button, {
          onClick: _ctx.fetchData,
          loading: _ctx.loading
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_ReloadOutlined)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 刷新 ")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vxe_table, {
          ref: "tableRef",
          border: "",
          "column-config": { resizable: true },
          height: "auto",
          size: "small",
          "show-overflow": "",
          "show-header-overflow": "",
          data: _ctx.tableData,
          loading: _ctx.loading,
          "scroll-x": { enabled: true },
          "scroll-y": { enabled: true, gt: 0 },
          "row-config": { isCurrent: true, isHover: true }
        }, {
          default: _withCtx(() => [
            (_ctx.isOperationCenter)
              ? (_openBlock(), _createBlock(_component_vxe_column, {
                  key: 0,
                  type: "checkbox",
                  width: "50",
                  fixed: "left"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_vxe_column, {
              field: "code",
              title: "开票信息编码",
              width: "140",
              fixed: "left"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorCode",
              title: "经销商编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorErpCode",
              title: "ERP客户编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "salesOrgCode",
              title: "销售组织",
              width: "100"
            }),
            _createVNode(_component_vxe_column, {
              field: "invoiceTitle",
              title: "发票抬头",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              field: "taxNo",
              title: "纳税人识别号",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              field: "bankName",
              title: "开户银行",
              width: "140"
            }),
            _createVNode(_component_vxe_column, {
              field: "approvalStatus",
              title: "审批状态",
              width: "140"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_OioTag, {
                  color: _ctx.approvalStatusColorMap[row.approvalStatus] || 'default'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.approvalStatusTextMap[row.approvalStatus] || row.approvalStatus), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                (row.approvalStatus === 'REJECTED' && row.rejectReason)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      title: row.rejectReason
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "businessLicenseFile",
              title: "营业执照",
              width: "80",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (row.businessLicenseFile)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: row.businessLicenseFile,
                      target: "_blank"
                    }, "查看", 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "未上传"))
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "createDate",
              title: "创建时间",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              title: "操作",
              width: "320",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_10, [
                  (!_ctx.isDistributor && _ctx.canEdit(row))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleEdit(row))
                      }, "编辑", 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (_ctx.isOperationCenter && row.approvalStatus === 'PENDING_APPROVAL')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.handleApprove(row)),
                        style: {"color":"#52c41a"}
                      }, "审批通过", 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.isOperationCenter && row.approvalStatus === 'PENDING_APPROVAL')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: ($event: any) => (_ctx.handleReject(row)),
                        style: {"color":"#ff4d4f"}
                      }, "审批拒绝", 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (_ctx.isOperationCenter)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        onClick: ($event: any) => (_ctx.handleDelete(row)),
                        style: {"color":"#ff4d4f"}
                      }, "删除", 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "loading"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_OioPagination, {
          currentPage: _ctx.pagination.current,
          pageSize: _ctx.pagination.pageSize,
          total: _ctx.pagination.total,
          showTotal: "",
          showJumper: "",
          onChange: _ctx.handlePaginationChange
        }, null, 8, ["currentPage", "pageSize", "total", "onChange"])
      ])
    ]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.showAddForm,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showAddForm) = $event)),
      title: _ctx.editingRecord ? '编辑开票信息' : '新增开票信息',
      width: "820px",
      "confirm-loading": _ctx.submitLoading,
      "enter-callback": _ctx.handleSubmit,
      "cancel-callback": _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_oio_form, {
          data: _ctx.formState,
          "label-col": { span: 8 },
          "wrapper-col": { span: 16 },
          class: "invoice-info-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "开票信息编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.code,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.code) = $event)),
                          placeholder: "保存后自动生成",
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "经销商编码",
                      rules: [{ required: true, message: '请输入经销商编码' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.distributorCode,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.distributorCode) = $event)),
                          placeholder: "经销商编码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "ERP客户编码",
                      rules: [{ required: true, message: '请输入ERP客户编码' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.distributorErpCode,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.distributorErpCode) = $event)),
                          placeholder: "ERP客户编码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "销售组织编码",
                      rules: [{ required: true, message: '请输入销售组织编码' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.salesOrgCode,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.salesOrgCode) = $event)),
                          placeholder: "销售组织编码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "发票抬头",
                      rules: [{ required: true, message: '请输入发票抬头' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.invoiceTitle,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.invoiceTitle) = $event)),
                          placeholder: "购方抬头名称"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "纳税人识别号",
                      rules: [{ required: true, message: '请输入纳税人识别号' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.taxNo,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.taxNo) = $event)),
                          placeholder: "纳税人识别号"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "开户银行" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.bankName,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.bankName) = $event)),
                          placeholder: "开户银行"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "银行账号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.bankAccount,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.bankAccount) = $event)),
                          placeholder: "银行账号"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "开票电话" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.phone,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.phone) = $event)),
                          placeholder: "开票电话"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "开票地址",
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 20 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.address,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.address) = $event)),
                          placeholder: "开票地址"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "寄送地址",
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 20 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.formState.deliveryAddress,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.deliveryAddress) = $event)),
                          placeholder: "发票邮寄地址"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "营业执照附件",
                      rules: [{ required: true, message: '营业执照附件必传' }],
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 20 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FileUpload, {
                          value: _ctx.licenseFileValue,
                          limit: 1,
                          accept: ".jpg,.jpeg,.png,.pdf",
                          onChange: _ctx.handleLicenseChange,
                          onRemove: _ctx.handleLicenseRemove
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_button, null, {
                              default: _withCtx(() => [
                                _createTextVNode("上传营业执照")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "onChange", "onRemove"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, {
                      label: "备注",
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 20 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.formState.remark,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.remark) = $event)),
                          placeholder: "备注信息",
                          rows: 2,
                          maxlength: 50,
                          "show-count": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible", "title", "confirm-loading", "enter-callback", "cancel-callback"]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.rejectVisible,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rejectVisible) = $event)),
      title: "驳回开票信息",
      width: "480px",
      "confirm-loading": _ctx.rejectLoading,
      "enter-callback": _ctx.handleRejectConfirm,
      "cancel-callback": _ctx.handleRejectCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(" 请输入驳回开票信息 "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.rejectingRecord?.code), 1),
          _createTextVNode(" 的原因： ")
        ]),
        _createVNode(_component_a_textarea, {
          value: _ctx.rejectReason,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rejectReason) = $event)),
          placeholder: "驳回原因（必填）",
          rows: 3,
          maxlength: 200,
          "show-count": ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "enter-callback", "cancel-callback"]),
    _createVNode(_component_ImportInvoiceInfoDialog, {
      visible: _ctx.importVisible,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.importVisible) = $event)),
      onSuccess: _ctx.fetchData
    }, null, 8, ["visible", "onSuccess"])
  ]))
}